import React, { useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUnreadNotificationsCount } from "../slices/thunks";
import type { AppDispatch } from "../store";

const Footer = () => {
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    const unreadCount = useSelector((state: any) => state.notifications?.unreadCount ?? 0);

    useEffect(() => {
        dispatch(getUnreadNotificationsCount());
    }, [dispatch, location.pathname, location.search]);

    return (
        <React.Fragment>
            <div className="footer-nav-area" id="footerNav">
                <div className="suha-footer-nav">
                    <ul className="h-100 d-flex align-items-center justify-content-between ps-0 d-flex rtl-flex-d-row-r">
                        <li><Link to="/order"><i className="mdi mdi-clipboard-text-outline"></i>Đơn hàng</Link></li>
                        <li><Link to="/menu"><i className="mdi mdi-food"></i>Menu</Link></li>
                        <li><Link to="/shop/qr"><i className="mdi mdi-qrcode-scan"></i>Mã QR</Link></li>
                        <li>
                            <Link to="/notifications" className="position-relative">
                                <i className="mdi mdi-bell"></i>
                                Thông báo
                                {unreadCount > 0 && (
                                    <span
                                        className="badge bg-danger rounded-pill position-absolute top-0 translate-middle"
                                        style={{ left: "60%" }}
                                    >
                                        {unreadCount}
                                    </span>
                                )}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
};
// mdi-note-plus-outline

export default Footer;
